<template>
  <div class="my-enquiry container">
    <div class="previewContent">
      <h1 class="previewTitle">{{ detailInfo.title }}</h1>
      <div class="previewDate">
        <div class="left">
          <div>发布日期 ： {{ detailInfo.publishTime || detailInfo.createTime }}</div>
          <div v-if="detailInfo.memberDepartment">文章来源 ： {{ detailInfo.memberDepartment }}</div>
          <div>
            <span class="el-icon-view"></span>
            <span class="view-num">{{ detailInfo.pageView }}</span>
          </div>
        </div>
        <div class="right">
          <eui-btn v-if="detailInfo.manageMentFiles && detailInfo.manageMentFiles.length" class="btn" @click="download">
            附件下载
          </eui-btn>
        </div>
      </div>
      <div class="short-description">
        {{ detailInfo.shortDescription }}
      </div>
      <div class="previewContentBox" v-html="detailInfo.content"></div>
    </div>

    <!-- 审批流组件-->
    <ApprovalProcess v-if="approvalData.length > 0" :approval-data="approvalData" />

    <div class="handle-button">
      <eui-btn type="secondary" @click="toBack()">< 返回</eui-btn>
      <div v-if="!isView" class="right-btn">
        <eui-btn type="weak" @click="handleApprove(2)">审批拒绝</eui-btn>
        <eui-btn @click="handleApprove(1)">审批通过</eui-btn>
      </div>
    </div>

    <EDialog
      :dialog-title="dialogTitle"
      :show-btn="true"
      :center-dialog-visible="visible"
      :popup-width="'600px'"
      @updateVisible="visible = false"
      @resetPopupData="visible = false"
      @submitPopupData="approveAnnouncement"
    >
      <div v-if="approveStatus === 1">
        <span>您正在操作公司公告审批通过，请详细核对公告信息。此操作无法撤销，是否继续？</span>
        <div class="line">
          审批意见：
          <el-input
            v-model="contents"
            type="textarea"
            :rows="2"
            placeholder="请输入"
            maxlength="300"
            show-word-limit
          ></el-input>
        </div>
      </div>
      <div v-else>
        <span>您正在操作公司公告审批拒绝，此操作无法撤销，是否继续？</span>
        <div class="line">
          <div>拒绝原因：</div>
          <el-input
            v-model="contents"
            type="textarea"
            :rows="2"
            placeholder="请输入"
            maxlength="300"
            show-word-limit
          ></el-input>
        </div>
      </div>
    </EDialog>
  </div>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog';
import ApprovalProcess from '@/modules/projectA/components/common/approvalProcess.vue';
import stepUtils from '@/modules/projectA/utils/stepUtils';
import Api from '@/modules/projectA/api/announcement';
import enApi from '@/modules/projectA/api/enquiry/index';
import auditApi from '@/modules/projectA/api/auditManagement';

export default {
  name: 'ProcurementPlanDetail',
  components: { EDialog, ApprovalProcess },
  props: {
    isView: Boolean,
  },
  data() {
    return {
      // 审核流程数据
      approvalData: [],
      // 弹窗审核数据
      contents: '',
      visible: false,
      dialogTitle: '',
      businessAuditId: '',
      approveStatus: '',

      detailInfo: {},
    };
  },
  mounted() {
    const { businessId } = this.$route.query;
    this.findAnnouncement(businessId);
  },
  methods: {
    handleApprove(approveStatus) {
      this.visible = true;
      this.dialogTitle = approveStatus === 1 ? '审批通过' : '审批拒绝';
      this.dialogType = approveStatus === 1 ? 'success' : 'warning';
      this.approveStatus = approveStatus;
    },
    async approveAnnouncement() {
      if (!this.contents && this.approveStatus === '2') {
        this.$message.error('输入拒绝原因。');
        return;
      }

      if (!this.contents && this.approveStatus === '1') {
        this.contents = '同意';
      }
      const { businessId } = this.$route.query;
      const params = {
        auditStatus: this.approveStatus,
        auditRemark: this.contents,
        auditList: [{ businessId: Number(businessId) }],
      };
      const res = await auditApi.batchAudit(params);
      if (res.code === '200') {
        this.$message.success(this.approveStatus === 1 ? '审批通过成功。' : '审批拒绝成功。');
        this.visible = false;
        this.contents = '';
        setTimeout(() => {
          const times = Date.now();
          this.toBack(times);
        }, 1000);
      }
    },
    toBack(times) {
      // 返回之前删除审批的tags
      this.$store.state.tagsList.forEach((item, index) => {
        if (item.fullPath === this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });

      if (times) {
        this.$router.push({
          path: '/auditManagement/announcement',
          query: { t: times },
        });
      } else {
        this.$router.push({ path: '/auditManagement/announcement' });
      }
    },

    async findAnnouncement(id) {
      // 查看咨询公告预览
      const { code, data } = await Api.queryAnnouncement({ id });
      if (code === '200') {
        this.detailInfo = data;
        this.queryAuditBusinessFlowLogList();
      }
    },

    // 获取审批流数据
    async queryAuditBusinessFlowLogList() {
      const { companyId } = JSON.parse(localStorage.getItem('USERINFO'));
      const params = {
        companyId,
        businessId: this.$route.query.businessId,
        businessAuditType: 8, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标 8:公告
      };
      const res = await enApi.queryAuditBusinessFlowLogList(params);
      if (res.code === '200' && res.data.length > 0) {
        const data = res.data || [];

        // 封装发起审批人数据
        const firstData = {
          step: '发起审批',
          icon: require('@/assets/img/approval/fqsp.png'),
          auditStatus: 1,
          nodeMember: {
            auditMemberPhone: this.detailInfo.mobile,
            auditMemberName: this.detailInfo.createName,
            approveTime: this.detailInfo.createTime,
          },
        };

        // 封装发起审批 的数据 插入第一条
        data.unshift(firstData);
        // 审批流数据封装
        this.approvalData = stepUtils.dealStepData(data);
      }
    },

    download() {
      const [file] = this.previewData.manageMentFiles;
      const downloadRes = async () => {
        const response = await fetch(file.attachmentUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = file.attachmentName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
  },
};
</script>

<style scoped lang="scss">
.my-enquiry {
  background: #fff;
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
}

.previewContent {
  display: flex;
  flex-direction: column;
  .previewTitle {
    font-size: 16px;
    color: #333;
    margin-bottom: 20px;
  }
  .previewDate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .left {
      flex: 1;
      display: flex;
      color: #999;
      font-size: 14px;
      div {
        margin-right: 30px;
      }
      .view-num {
        margin-left: 4px;
      }
    }
  }
  .short-description {
    padding: 11px 20px;
    background-color: #fff;
    color: #666666;
    font-size: 16px;
    line-height: 32px;
    font-weight: 400;
    margin-bottom: 20px;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
  }
  .previewContentBox {
    ::v-deep em {
      font-style: italic;
    }
    ::v-deep img {
      max-width: 100% !important;
    }
    ::v-deep video {
      max-width: 100%;
    }
    ::v-deep a {
      word-break: break-all;
    }
    ::v-deep table {
      border-collapse: collapse;
      td {
        border: 1px solid #ccc;
        line-height: 1.5;
        min-width: 30px;
        padding: 3px 5px;
        text-align: left;
      }
      th {
        border: 1px solid #ccc;
        line-height: 1.5;
        min-width: 30px;
        padding: 3px 5px;
        background-color: #f5f2f0;
        font-weight: 700;
        text-align: center;
      }
    }
    ::v-deep ul {
      li {
        list-style: disc;
        list-style-position: inside;
      }
    }
    ::v-deep ol {
      li {
        list-style: decimal;
        list-style-position: inside;
      }
    }
    ::v-deep #noticeNote {
      font-size: 14px;
    }
    ::v-deep h5 {
      font-weight: bold;
    }
  }
}

.previewContentBox ::v-deep img {
  max-width: 100%;
}
</style>
